import { useContext,useMemo } from "react";
import SentimentDrivers from "../SentimentDriver/SentimentDriver";
import PersonaSummary from "./PersonaSummary";
import { DiscoveryContext, useIsSelectedSection } from "../discovery-context";
import MUISelect from "../../../Component/UI/MUISelect/MUISelect";
import classes from "./PersonaOverview.module.css";
import { LLM_OPTIONS } from "../../../utils/constant";
import { filterKey } from "../BrandAudit";
import { tab } from "../BrandScore/BrandScore";
import Checkbox from "@mui/material/Checkbox";
import {OVERVIEW_LLM_LABELS} from "../../../utils/constant"
import DashboardCheckbox from "../SelectedComponent/DashboardCheckbox";

export default function PersonaOverview() {
  const discoveryCtx = useContext(DiscoveryContext);
  const id = "Sentiment_Drivers";

  const { checked, uniqueKey } = useIsSelectedSection({
    id,
    tab: tab.personaOverview,
  });

const personaOptions = useMemo(() => {
  return (discoveryCtx?.persona || [])
    .map(p => {
      // New record format
      if (typeof p === "object" && p?.title) {
        return {
          name: p.title,
          value: p.title,
        };
      }

      // Old record format
      if (typeof p === "string") {
        return {
          name: p,
          value: p,
        };
      }

      return null;
    })
    .filter(Boolean);
}, [discoveryCtx?.persona]);

  return (
    <>
      <div className={classes.containerWrapper}>
         {discoveryCtx.state.showReportCheckbox && (
            <DashboardCheckbox
              dashboardTab={tab.personaOverview}
              dashboardName={`Persona Overview`}
             />
            )}
        <PersonaSummary />
        <div className={classes.headerWrapper}>
          <div style={{display:'flex' ,gap:'10px', alignItems:'center'}}>
            <h5 className={classes.heading}>Sentiment Drivers</h5>
            {discoveryCtx.state.showReportCheckbox && (
              <Checkbox
                checked={checked}
                onChange={() => {
                  discoveryCtx?.clickComponentCheckbox({
                    uniqueKey,
                    filter: {
                      id: id,
                      title: discoveryCtx?.mapMetricTitle?.("Sentiment Drivers") ?? "Sentiment Drivers",
                      tab: tab.personaOverview,
                      uniqueKey,
                    },
                    checked,
                  });
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
            )}
          </div>
          <div className={classes.dropdownWrapper}>
            <MUISelect
              fullWidth={false}
              optionValue={discoveryCtx.state.selectedLLM}
              label={"LLM"}
              id={filterKey.llm}
              options={(discoveryCtx.llm || []).map((llm) => {
                 const match= OVERVIEW_LLM_LABELS[llm]
                return {
                  name: match ? match : llm,
                  value: llm,
                };
              })}
              onChange={(e) => {
                discoveryCtx.updateSelectedLLM(e.target.value);
              }}
            />
             <MUISelect
              fullWidth={false}
              optionValue={discoveryCtx.state.selectedPersona}
              label={"Persona"}
              id={filterKey.persona}
              options={personaOptions}
              onChange={(e) => {
                discoveryCtx.updateSelectedPersona(e.target.value);
              }}
            /> 
          </div>
        </div>
        <SentimentDrivers isSelectedMarket={true}/>
      </div>
    </>
  );
}
